export class FulfillmentCriteria {
    agentID: string  = ""
	orgID: number = 0
	orgName: string = ""
    planYear: string  = ""
    startDate: string  = ""
	endDate: string = ""
    SKU: string  = ""
    failureSwitch: string  = ""
    consumerSwitch: string  = ""
    eventID: number  = 0
    status: string = "Any"
    PageSize: number = 50
    PageNumber: number = 1
    SortFields: string = ""
}